import { render } from "./hosterInvitePerson.vue?vue&type=template&id=21cb0969&ts=true"
import script from "./hosterInvitePerson.vue?vue&type=script&lang=ts"
export * from "./hosterInvitePerson.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__